//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import Cookies from "js-cookie";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    if (!user?.username || !user?.password) {
      throw new Error("Username and password are required");
    }
    const response = await postJwtLogin({
      username: user.username,
      password: user.password,
    });

    if (!response) {
      throw new Error("No response received from authentication service");
    }

    const authData = response;
    const token = authData.access;

    Cookies.set("authUser", JSON.stringify(authData), { expires: 7, sameSite: "Strict" });
    Cookies.set("authToken", token, { expires: 7, sameSite: "Strict" });

    dispatch(loginSuccess(authData));
    history("/contracts");

  } catch (error) {
    console.log("error")
    dispatch(apiError({ message: error.message || "Authentication failed", status: "error" }));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {

    Cookies.remove("authUser");
    Cookies.remove("authToken");

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};


export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
